import {format} from 'date-fns'

export const thousandSeparator = num =>{  
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const FormatDateAndTime = (date = new Date()) =>{  
    return format(new Date(date),'dd-MMM-yyyy hh:mm b')
}

export const FormatDate = (date = new Date()) =>{  
    return format(new Date(date),'dd-MMM-yyyy')
}

export const FormatTime = (date = new Date()) =>{  
    return format(new Date(date),'hh:mm b')
}